"use strict";

module.exports = /* @ngInject */ function(
  $location,
  $interval,
  authTokenProvider,
  rediTokenService
) {
  var that = this;

  var TITLE_UPDATE_INTERVAL = 100;

  document.title = "";

  function initialize() {
    var authToken = authTokenProvider.get();
    if (authToken !== null) {
      rediTokenService
        .getUserInfoFromAccessToken(authToken.access_token)
        .then(function(userInfo) {
          console.log(
            "User " + userInfo.username + " is authenticated, forwarding."
          );
          that.url = $location.search().url;
        })
        .catch(function() {
          console.log(
            "Access token is no longer valid, authorizing again by eikon session token."
          );
          postAuthByEikonSession();
        });
    } else {
      postAuthByEikonSession();
    }
  }

  function postAuthByEikonSession() {
    rediTokenService.postAuthByEikonSessionToken().then(
      function(authToken) {
        console.log(
          "Eikon session is valid, storing OAuth token and loading window"
        );
        rediTokenService.storeAuthTokenFrom(authToken);
        that.url = $location.search().url;
      },
      function() {
        console.error(
          "Eikon Session not valid and REDI Auth token is not set, can not load window"
        );
      }
    );
  }

  var intervalPromise = $interval(function() {
    if (that.url) {
      setWindowTitle();
    }
  }, TITLE_UPDATE_INTERVAL);

  var setWindowTitle = function() {
    try {
      var iframe = document.getElementById("window-container");
      var containedWindowTitle = iframe.contentDocument.title;
      document.title = containedWindowTitle;
    } catch (exception) {
      $interval.cancel(intervalPromise);
      document.title = that.url;
    }
  };

  initialize();
};



// WEBPACK FOOTER //
// ./app/presentation/controllers/WindowController.js